import { fetch } from 'utils/fetch';
import Vue from 'vue';

// 获取币种名称
export const getCurrencyName = (code) =>
  fetch({
    url: '/api/Currency/Language/getCurrencyNaemByLanguage',
    method: 'GET',
    params: {
      code,
      language: 'chineseName',
    },
  });

// 获取发票类型
export const getInvoiceTypes = (userOID, isHand = false, cardSignType, expenseReportOID) =>
  fetch({
    url: '/api/custom/enumeration/receipt/type',
    method: 'GET',
    params: {
      userOID,
      isHand,
      cardSignType,
      expenseReportOID,
    },
  });

export const getPayee = (params) => {
  return fetch({
    url: '/receipt/api/receipt/vicp/payee',
    method: 'GET',
    params,
  });
};

export const getFoldPayee = (params) => {
  return fetch({
    url: '/receipt/api/receipt/vicp/payee/housekeeper',
    method: 'GET',
    params,
  });
};

export const getTitle = (params) => {
  return fetch({
    url: '/receipt/api/receipt/vicp/titles',
    method: 'GET',
    params,
  });
};

export const getFoldTitle = (params) => {
  return fetch({
    url: '/receipt/api/receipt/vicp/titles/housekeeper',
    method: 'GET',
    params,
  });
};

/**
 * 获取发票控件字段管控
 * @returns {*}
 */
export const postInvoiceConfig = (tenantId, data) =>
  fetch({
    url: '/config/api/config/hit/RECEIPT_DISPLAY_CONTROL',
    method: 'POST',
    params: {
      tenantId,
    },
    data,
  });

// 查询当前用户所属法人是否开通票++
export const checkInvoiceEnable = (userOID, expenseReportOID) =>
  fetch({
    url: '/api/receipt/check/enable',
    params: {
      userOID,
      expenseReportOID,
    },
    method: 'GET',
  });
// 邮箱入口
export const getEmailEnable = (userOID) =>
  fetch({
    url: '/api/receipt/mail/enable',
    params: {
      userOID,
    },
    method: 'GET',
  });

// 发票查验
export const checkoutInvoice = (data) =>
  fetch({
    url: '/receipt/api/receipt/verify/batch',
    method: 'POST',
    data: data,
  });

// 发票管家单独查验
export const receiptFoldCheckoutInvoice = (data) =>
  fetch({
    url: '/receipt/api/receipt/verify/batch/housekeeper',
    method: 'POST',
    data: data,
  });

export const verifyTaxRate = (params) =>
  fetch({
    url: '/receipt/api/tax/check',
    method: 'GET',
    params,
  });
/**
 * 获取支付宝是否需要权限处理
 * @param userOID
 * @returns {Promise | Promise<unknown> | undefined}
 */
export const getAliPayAuthority = (userOID) =>
  fetch({
    url: '/api/tenant/bankcard/status/ALIPAY',
    method: 'GET',
    params: {
      userOID,
    },
  });
// 获取支付宝权限链接
export const getAliPayAuthorityUrl = (params) =>
  fetch({
    url: '/receipt/api/receipt/alipay/auth/url',
    method: 'GET',
    params,
  });

// 获取税率列表
export const getRateList = () =>
  fetch({
    url: '/api/custom/enumeration/tax/rate',
    method: 'GET',
  });

// 获取我的账本费用列表
export const getMyExpenses = (data) => {
  return fetch({
    url: '/api/invoices/my',
    method: 'POST',
    data,
  });
};
// 获取费用筛选信息
export const getExpenseListFilter = (params) =>
  fetch({
    url: '/api/invoice/factor/filter/invoices',
    method: 'GET',
    params,
  });

// 报销单导入可选费用
export const getImportInvoice = (data) => {
  return fetch({
    url: `/api/expense/report/invoices/import/search?page=${data.page}&size=${data.size}`,
    method: 'POST',
    data,
  });
};

// 报销单导入不可选费用
export const getImportInvoiceDisabled = (data) => {
  return fetch({
    url: `/api/expense/report/unavailable/invoices/search?page=${data.page}&size=${data.size}`,
    method: 'POST',
    data,
  });
};

// 报销单导入申请单费用
export const getImportApplicationInvoice = (data) => {
  return fetch({
    url: `/api/expense/report/application/budgets/search?page=${data.page}&size=${data.size}`,
    method: 'POST',
    data,
  });
};

export const importAllApplicationInvoice = (data) => {
  return fetch({
    url: '/api/expense/report/application/budgets/import/pick/all',
    method: 'POST',
    data,
  });
};

//报销单导入不可选费用
export const getImportUnavialable = (data) => {
  return fetch({
    url: `/api/expense/report/invoices/import/unavailable/search?page=${data.page}&size=${data.size}`,
    method: 'POST',
    data,
  });
};

// 获取费用数量--弃用
export const getInvoicesCount = () => {
  return fetch({
    url: '/invoice/api/invoices/count',
    method: 'GET',
  });
};
// 费用转交
export const invoiceTransfer = (data) => {
  return fetch({
    url: '/invoice/api/invoices/transfer/to',
    method: 'POST',
    data,
  });
};
export const deleteBatchInvoice = (data) => {
  return fetch({
    url: '/api/invoice/batch',
    method: 'DELETE',
    nativeResponseSerializer: 'number',
    params: {
      invoiceOIDs: data.join(','),
    },
  });
};
// 导入费用全选
export const importAllExpense = (data) => {
  return fetch({
    url: `/api/expense/report/invoices/import/pick/all?page=${data.page}&size=${data.size}`,
    method: 'POST',
    data,
  });
};

// 获取代提人列表 老接口可以废除
export const getOwnerProxy = (params) => {
  return fetch({
    url: '/api/expense/report/invoices/owner/search',
    method: 'GET',
    params,
  });
};
// 获取代提人列表
export const getOwnerProxyV2 = (params) => {
  return fetch({
    url: '/api/expense/report/participant/search',
    method: 'GET',
    params,
  });
};
//费用保存 v5
export const postInvoiceSave = (data) =>
  fetch({
    url: '/invoice/api/v5/invoices?isDateCombinedUTC=false&utcTime=true',
    method: 'POST',
    data: data,
    timeout: 60000,
  });

//费用保存 v6 异步
export const postInvoiceSaveV6 = (data) =>
  fetch({
    url: '/invoice/api/v6/invoices?isDateCombinedUTC=false&utcTime=true',
    method: 'POST',
    data: data,
    timeout: 60000,
  });

export const asyncSaveExpense = (data) => {
  return fetch({
    url: '/invoice/api/validate/invoice/async',
    method: 'POST',
    data: data,
    timeout: 60000,
  });
};

// 费用删除 退回账本
export const deleteInvoice = ({ expenseReportOID, invoiceOID }) => {
  return fetch({
    url: `/api/expense/reports/remove/invoice/${expenseReportOID}/${invoiceOID}`,
    method: 'DELETE',
  });
};
// 费用删除 物理删除
export const physicalDeletionInvoice = ({ expenseReportOID, invoiceOID }) => {
  return fetch({
    url: `/api/expense/reports/delete/invoice/${expenseReportOID}/${invoiceOID}`,
    method: 'DELETE',
  });
};

//获取账本导入费用列表接口
export const getInvoicesList = (page, size, params) =>
  fetch({
    url: '/api/v2/invoices/currency?page=' + page + '&size=' + size,
    method: 'POST',
    data: params,
  });

// 获取费用类型
export const getExpenseCategory = (params) =>
  fetch({
    url: '/api/expense/types/category',
    method: 'GET',
    params,
  });

// 获取详细费用类型
export const getAllExpense = (params) =>
  fetch({
    url: '/api/expense/types/query',
    method: 'GET',
    params,
  });

export const getExpenseList = () =>
  fetch({
    url: '/api/expense/types/pasteType?createManually=true&pasteInvoiceNeeded=true',
    method: 'GET',
  });

export const getExchangeRate = (companyOID) =>
  fetch({
    url: '/api/get/exchange/rate?companyOID=' + companyOID,
    method: 'GET',
  });

// 获取申请单预算类型选择历史
export const getApplicationBudgetTypeHistory = ({
  formOID,
  page = 0,
  size = 5,
  applicantOID,
  createManually,
  subsidyType,
  companyOID,
}) => {
  return fetch({
    url: '/api/application/budget/type/history',
    method: 'GET',
    params: {
      createManually,
      page,
      formOID,
      size,
      subsidyType,
      applicantOID,
      companyOID,
    },
  });
};

// 获取费用类型选择历史
// 老版微信使用历史选择费用类型接口
export const getInvoiceHistory = ({ withReceipt, customFormOID }) => {
  return fetch({
    url: '/api/invoice/history/record',
    method: 'GET',
    params: {
      createManually: true,
      page: 0,
      size: 5,
      withReceipt,
      customFormOID,
    },
  });
};

/**
 * 获取推荐费用类型
 */
export const getRecommendedInvoiceHistory = ({
  customFormOID,
  receipts,
  applicationOID,
  applicantOID,
  createManually,
  withReceipt,
  expenseReportOID,
  configResults,
  multipleInvoiceSupported,
  companyOID = undefined,
  reportDepartmentOID,
  costCenterItemOID,
  bankTransactionIdList,
}) => {
  (customFormOID === 'default' || !customFormOID) && (customFormOID = null);
  (applicationOID === 'default' || !applicationOID) && (applicationOID = null);

  let data = {
    receipts,
    applicationOID,
    customFormOID,
    createManually,
    withReceipt,
    multipleInvoiceSupported,
    applicantOID,
    configResults,
    expenseReportOID,
    companyOID,
    reportDepartmentOID,
    costCenterItemOID,
    bankTransactionIdList,
  };
  // 报销单时删除表单id
  if (expenseReportOID) {
    delete data.customFormOID;
    delete data.companyOID;
  }
  return fetch({
    url: '/api/invoice/history/record/v2',
    method: 'POST',
    params: {
      page: 0,
      size: 5,
    },
    data,
  });
};

export const getInvoiceType = () => {
  return fetch({
    url: '/api/invoice/invoiceType',
    method: 'GET',
  });
};

//获取微信电子发票
export const getInvoiceDetail = (data) =>
  fetch({
    url: '/receipt/api/receipt/wx/detail/batch/v2',
    method: 'POST',
    data: data,
  });
// v2删除费用 部分费用删除需要二次确认
export const deleteInvoiceByOID = (invoiceOID, params = {}) => {
  return fetch({
    url: '/api/v2/invoice/' + invoiceOID,
    method: 'DELETE',
    params,
  });
};

export const getInvoice = (invoiceOID, isFromReport = false) => {
  return fetch({
    url: `/api/invoices/${invoiceOID}?isDateCombinedUTC=false&isFromReport=${isFromReport}`,
    method: 'GET',
  });
};

export const getExpenseTypeByOID = (expenseTypeOID, params) => {
  return fetch({
    url: '/api/expense/types/select/' + expenseTypeOID,
    method: 'GET',
    params: {
      ...params,
      attachmentFieldAsComponent: true,
    },
  });
};

/**
 * 获取用户可选的费用类型
 * @param data
 *  expenseReportOID 报销单OID
 *  createManually：是否只返回可手工创建的费用类型
 *  applicationOID 申请单OID
 *  userOID：申请人OID, 代理提交时可以查看到申请人权限范围内的费用类型
 *  pasteInvoiceNeeded 是否需要贴票
 *  multipleInvoiceSupported 是否支持多发票
 *  configResults 发票查验结果 可选
 *  queryNotSupportedType 是否展示禁用
 */
export const getAllExpenseTypes = (data) => {
  delete data.multipleInvoiceSupported;
  return fetch({
    url: '/api/expense/type/byUser',
    method: 'POST',
    data: {
      ...data,
      queryNotSupportedType: true,
    },
  });
};

// 查询用户可选的费用类型：/api/expense/type/byUser

//import selectPersonApi from "api/application/person"
export const getSearchUsersBy = (page, size, keyword) => {
  return fetch({
    url: '/api/search/users/by/' + keyword + '?page=' + page + '&size=' + size,
    method: 'GET',
  });
};

export const getUsersBy = (page, size) => {
  return fetch({
    url: '/api/users?page=' + page + '&size=' + size,
    method: 'GET',
  });
};

export const getInvoiceDetailByAlipay = (invoiceToken) => {
  return fetch({
    url: '/receipt/api/receipt/alipay/details',
    method: 'POST',
    data: {
      invoiceToken: invoiceToken,
    },
  });
};

export const getEnumerationsList = (page, size) => {
  return fetch({
    url: '/api/users?page=' + page + '&size=' + size,
    method: 'GET',
  });
};

export const getEnumerationsListByKey = (page, size, userOID, keyword) => {
  return fetch({
    url: '/receipt/api/receipt/alipay/details',
    method: 'POST',
    data: {
      // invoiceToken: invoiceToken
    },
  });
};
// 查询默认分摊
export const queryDefaultApportionment = async (data) => {
  const res = await fetch({
    url: '/api/expense/default/apportionment',
    method: 'POST',
    data,
  });
  const { notHitCompanyApportionMessage } = res.data[0] || {};
  notHitCompanyApportionMessage && Vue.$handPlugin.toast.show(notHitCompanyApportionMessage);
  return res;
};

export const getImportApportions = (params) => {
  return fetch({
    url: '/api/expense/apportionment/merge/related',
    method: 'GET',
    params,
  });
};
export const getApportionsParticipant = (params) => {
  return fetch({
    url: '/api/expense/relevant/in/participant',
    method: 'GET',
    params,
  });
};
// 查询关联申请单的分摊详情
export const getApplicationApportionDetail = (applicationApportionmentId, expenseReportOID) => {
  return fetch({
    url: `/api/expense/apportionment/related/${applicationApportionmentId}?expenseReportOID=${expenseReportOID}`,
    method: 'GET',
  });
};
//
export const getApplicationApportionDetailV2 = (params) => {
  return fetch({
    url: '/api/expense/apportionment/related/merge',
    method: 'GET',
    params,
  });
};
//
export const shouldShowContractApportion = (params) => {
  return fetch({
    url: '/api/contract/related/apportionment/button/v2',
    method: 'GET',
    params,
  });
};

//查询关联合同分摊列表
export const getContractApportionList = (params) => {
  return fetch({
    url: '/api/contract/related/apportionment/list',
    method: 'GET',
    params,
  });
};

//查询单个关联合同分摊详情
export const getContractApportionDetail = (params) => {
  return fetch({
    url: '/api/contract/related/apportionment/detail',
    method: 'GET',
    params,
  });
};

export const fetchInvoiceHeaderList = (companyOID) => {
  return fetch({
    url: '/api/invoice/header/list?companyOID=' + companyOID,
    method: 'GET',
  });
};

// 获取差补类型V2
export const getExpenseTravelTypes = (params) => {
  return fetch({
    url: '/api/expense/report/v4/subsidy/add',
    method: 'POST',
    data: params,
  });
};

// 保存补贴信息接口
export const saveSubsidy = (expenseReportOID, subsidyDTOS) => {
  return fetch({
    url: `/api/expense/report/subsidy/save/${expenseReportOID}`,
    method: 'POST',
    data: subsidyDTOS,
  });
};

// 保存补贴信息接口
export const saveSubsidyV3 = (expenseReportOID, subsidyDTOS) => {
  return fetch({
    url: `/api/expense/report/v3/subsidy/save/${expenseReportOID}`,
    method: 'POST',
    data: subsidyDTOS,
    timeout: 300000,
  });
};

// 保存差补时间
export const saveTravelTime = (data) => {
  return fetch({
    url: '/api/subsidy/extend/update',
    method: 'POST',
    data,
  });
};

// 新增或者修改差旅大行程
export const saveSubsidySingleV3 = (data) => {
  return fetch({
    url: '/api/v3/subsidy/extend/update',
    method: 'POST',
    data,
  });
};

// 图片上传查验
export const ocrCheckoutInvoice = (params) => {
  return fetch({
    url: '/receipt/api/asbw/ocr/verify',
    method: 'POST',
    data: params,
  });
};

// 票小秘查验
export const ocrPXMCheckoutInvoice = (params, flag = false) => {
  return fetch({
    url: `/receipt/api/receipt/ocr?isInternationalOCR=${flag}`,
    method: 'POST',
    data: params,
  });
};

export const ofdCheckoutInvoice = (params) => {
  return fetch({
    url: '/receipt/api/receipt/ofd',
    method: 'POST',
    data: params,
  });
};

export const xmlCheckoutInvoice = (params) => {
  return fetch({
    url: '/receipt/api/receipt/xml/parse',
    method: 'POST',
    data: params,
  });
};

// 获取差补信息
export const getTravelInfo = (expenseReportOID) => {
  return fetch({
    url: '/api/expense/report/subsidy/view',
    method: 'GET',
    params: {
      expenseReportOID,
    },
  });
};

// 获取差补信息
export const deleteSingleSubsidy = (subsidyExtendID) => {
  return fetch({
    url: `/api/expense/report/v2/subsidy/delete/single?subsidyExtendID=${subsidyExtendID}`,
    method: 'DELETE',
  });
};
export const getThirdDateInfo = (params) => {
  return fetch({
    url: '/api/expense/report/subsidy/calendar/third/info',
    method: 'GET',
    params,
  });
};
/*
  获取差补行程列表，优化接口getTravelInfo
 */
export const getSubsidyList = (expenseReportOID) => {
  return fetch({
    url: '/api/expense/report/v3/subsidy/view',
    method: 'GET',
    params: {
      expenseReportOID,
      isDateCombinedUTC: false,
    },
  });
};
// 自动计算行程
export const autoCalculateSubsidy = (params) => {
  return fetch({
    url: '/api/expense/report/auto/subsidy',
    method: 'GET',
    params,
  });
};

// 获取费用差补详细信息
export const getTravelList = (params) => {
  return fetch({
    url: '/api/expense/report/subsidy/detail',
    method: 'GET',
    params,
  });
};

// 获取费用差补详细信息V2
export const getTravelListV2 = (params) => {
  return fetch({
    url: '/api/expense/report/v2/subsidy/detail',
    method: 'GET',
    params,
  });
};

export const getExpenseRelateApplication = (
  page,
  size,
  applicantOID = '',
  expenseTypeId = '',
  keyword = '',
  isPublic,
  invoiceOID,
  expenseReportOID
) => {
  return fetch({
    url: isPublic ? '/api/expense/applications/invoice/refer/public' : '/api/expense/applications/invoice/refer',
    method: 'GET',
    params: {
      page,
      size,
      appKeyword: keyword,
      applicantOID,
      expenseTypeId,
      invoiceOID,
      expenseReportOID,
    },
  });
};

export const getApplicationByNo = (applicationNumber, tenantID) => {
  return fetch({
    url: '/api/invoice/applicationOID/by/applicationNumber',
    method: 'GET',
    params: {
      applicationNumber,
      tenantID,
    },
  });
};

export const getAssociateBudget = (params) => {
  return fetch({
    url: '/invoice/api/itinerary/budget/query_for_invoice',
    method: 'GET',
    params,
  });
};
// 是否可关联多发票
export const isMultipleRelateApplicant = (expenseReportFormOID) => {
  return fetch({
    url: '/api/expense/report/application/check',
    method: 'GET',
    params: {
      expenseReportFormOID,
    },
    nativeResponseSerializer: 'boolean',
  });
};

export const postBatchChangePayee = (data) => {
  return fetch({
    url: '/api/originpayment/batchChangePayeeInfo',
    method: 'POST',
    data,
  });
};

export const getPaymentRemark = (params) => {
  return fetch({
    url: '/api/default/payment/remark/custom/enumeration/item/query',
    method: 'GET',
    params,
  });
};

// 查询报销单收款方信息
export const getPayeesByExpOID = (expOid) => {
  return fetch({
    url: '/api/payment/schedule/query/by/expOid',
    method: 'GET',
    params: {
      expOid,
    },
  });
};

// 根据单据收款方信息查询收款行
export const getPayeesPaymentSchedule = (page, size, payeeId, accountNumber, expOid) => {
  let params = {
    page,
    size,
    payeeId,
    expOid,
  };
  if (accountNumber) {
    params.accountNumber = accountNumber;
  }
  return fetch({
    url: '/api/payment/schedule/query/page/by/payee/msg',
    method: 'GET',
    params,
  });
};

/**
 * 获取收款方待还款列表
 * @param companyOID
 * @param currencyCode
 * @param payeeId
 * @param paymentScheduleId
 * @param applicationOIDs
 * @param contractHeadIds
 * @param setOfBooksId
 * @param corporationOID
 * @param expenseReportOID
 * @param paymentPurposeId
 * @returns {*}
 */
export const getPayeeLoanLineList = ({
  companyOID,
  currencyCode,
  payeeId,
  paymentScheduleId,
  applicationOIDs = [],
  contractHeadIds,
  setOfBooksId,
  corporationOID,
  expenseReportOID,
  paymentPurposeId,
}) => {
  applicationOIDs = applicationOIDs.join(',');
  let params = {
    companyOID,
    currencyCode,
    payeeId,
    paymentScheduleId,
    setOfBooksId,
    corporationOID,
    contractHeadIds,
    expenseReportOID,
    paymentPurposeId,
  };
  if (applicationOIDs) {
    params.applicationOIDs = applicationOIDs;
  }
  return fetch({
    url: '/api/loan/line/my/writeOff',
    method: 'GET',
    params,
  });
};

/**
 * 核销借款行
 * @param data
 * @param paymentScheduleId
 * @returns {*}
 */
export const postWriteOffLines = (data, paymentScheduleId) => {
  return fetch({
    url: `/api/repayment/write/off/${paymentScheduleId}`,
    method: 'POST',
    data,
  });
};
/**
 * 是否存在支持多发票的费用类型
 * @returns {*}
 */
export const isSupportMultipleInvoice = (data) => {
  return fetch({
    url: '/api/expense/type/multi/invoice/supported',
    method: 'POST',
    data,
  });
};
/**
 * 费用是否可复制
 * @param query
 * @returns {*}
 */
export const validateCopyInvoice = (query) => {
  return fetch({
    url: '/invoice/api/copy/validate',
    method: 'GET',
    params: query,
  });
};
// 获取messsageKey获取费用类型
export const getExpenseTypeByKey = (messageKey) => {
  return fetch({
    url: `/api/expense/types/by/key?messageKey=${messageKey}`,
    method: 'GET',
  });
};

/**
 * 获取原币金额及原币税额
 * @param data
 * @returns {*}
 */
export const getInvoiceTaxAmount = (data) => {
  return fetch({
    url: '/invoice/api/invoice/tax/amount/by/receipts',
    method: 'POST',
    data,
  });
};
/**
 * 获取发票总金额
 * @param data
 * @returns {*}
 */
export const getReceiptTotalAmount = (data) => {
  return fetch({
    url: '/invoice/api/receipt/cal/total_amount',
    method: 'POST',
    data,
  });
};
/**
 * 获取商务卡总金额
 * @param data
 * @returns {*}
 */
export const getBusinessCardTotalAmount = (data) => {
  return fetch({
    url: '/invoice/api/bankTransaction/cal/total_amount',
    method: 'POST',
    data,
  });
};
/**
 * 获取费用默认值
 * @param data
 * @returns {*}
 */
export const getInvoiceDefaultValue = (data) => {
  return fetch({
    url: '/invoice/api/invoice/defaults?isDateCombinedUTC=false',
    method: 'POST',
    data,
  });
};

export const getDefaultHeader = (params) => {
  return fetch({
    url: '/invoice/api/get/city/default/value',
    method: 'GET',
    params,
  });
};
/**
 * @param formOID
 * @desc 获取付款方式类型
 */
export const getApplicationPaymentType = (formOID) => {
  return fetch({
    url: `/api/originpayment/payment/method/query/${formOID}`,
    method: 'GET',
  });
};

/**
 * @param formOID
 * @desc 获取付款方式用途
 */
export const getApplicationPaymentMethod = (formOID) => {
  return fetch({
    url: `/api/originpayment/payment/purpose/query/${formOID}`,
    method: 'GET',
  });
};
/**
 * 获取发票填写图片信息
 * @param typeNo 发票类型
 * @returns {*}
 */
export const getReceiptTipImg = (typeNo) =>
  fetch({
    url: `/api/receipt/type/image/${typeNo}`,
    method: 'GET',
    nativeResponseSerializer: 'string',
  });

/**
 * 获取发票修改记录
 * @param receiptId 发票id
 * @returns {*}
 */
export const getReceiptChangeHistory = (receiptId, checkResult, pdfDamaged = false) =>
  fetch({
    url: '/api/receipt/query/label/detail',
    method: 'POST',
    data: {
      id: receiptId,
      checkResult,
      pdfDamaged,
    },
  });

export const getReceiptChangeHistoryByInvoice = (receipt) =>
  fetch({
    url: '/api/receipt/query/label/detail',
    method: 'POST',
    data: receipt,
  });
/**
 * @desc 获取差补值列表
 * @param params
 * @returns {*}
 */
export const getTravelRules = (params) =>
  fetch({
    url: '/api/expense/report/subsidy/enumeration',
    method: 'GET',
    params,
  });

/**
 * @desc 获取差旅规则值列表
 * @param enumerationOID
 * @param params
 * @returns {*}
 */
export const getTravelRulesValue = (enumerationOID, params) =>
  fetch({
    url: `/api/custom/enumerations/${enumerationOID}/items/v2`,
    method: 'GET',
    params,
  });

/**
 * 报销单修改是否需要修改差补信息
 * @param data
 * @returns {*}
 */
export const getSubsidyChangeStatus = (data) =>
  fetch({
    url: '/api/expense/report/subsidy/change/check',
    method: 'POST',
    data,
    nativeResponseSerializer: 'boolean',
  });

/**
 * 是否开通批量分摊
 * @param params
 * @returns {*}
 */
export const getBatchApportionEnabled = (params) =>
  fetch({
    url: '/api/expense/report/batch/apportion/enabled',
    method: 'GET',
    params,
  });

/**
 * 获取报销单默认分摊行
 * @param params
 * @returns {*}
 */
export const getClaimDefaultApportion = async (params) => {
  const res = await fetch({
    url: '/api/expense/apportionment/batch/default',
    method: 'GET',
    params,
  });
  const { notHitCompanyApportionMessage } = res.data[0] || {};
  notHitCompanyApportionMessage && Vue.$handPlugin.toast.show(notHitCompanyApportionMessage);
  return res;
};

/**
 * 获取对公到票分摊列表
 * @param id
 * @returns {*}
 */
export const getCorporatePayList = (id) =>
  fetch({
    url: `/api/corp/payment/schedule/apportion/available?expId=${id}`,
    method: 'GET',
  });
/**
 * 报销单应用分摊
 * @param data
 * @returns {*}
 */
export const applyClaimApportion = (data) =>
  fetch({
    url: '/api/expense/apportion/plan/apply',
    method: 'post',
    data,
  });
/**
 * 获取费用归属人选择列表
 * @param params
 * @returns {*}
 */
export const getExpenseParticipantsList = (params) =>
  fetch({
    url: '/api/expense/participantsList',
    method: 'GET',
    params,
  });
/**
 * 删除发票
 * @param receiptId
 * @returns {*}
 */
export const deleteReceipt = (receiptId) => {
  return fetch({
    url: `/receipt/api/receipts/${receiptId}`,
    method: 'DELETE',
  });
};

export const batchDeleteReceipt = (data) => {
  return fetch({
    url: '/receipt/api/receipts/delete/batch/byId',
    method: 'POST',
    data,
  });
};

/**
 * 判断清空成本中心逻辑
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
export const getCostCenterVisible = (data) =>
  fetch({
    url: '/api/cost/center/item/by/batch/condition/visible',
    method: 'POST',
    data,
  });

//  修改参与人获取分摊成本中心
export const getDefaultCostByPerson = (params) =>
  fetch({
    url: '/api/apportion/cost/center/item/search',
    method: 'GET',
    params,
  });
// 是否开通发票夹
export const getReceiptFolderEnable = (params) =>
  fetch({
    url: '/api/receipt/folder/check/opened',
    method: 'GET',
    params,
  });
// 查询发票夹列表
export const getInvoiceFolderList = (params) => {
  return fetch({
    url: '/api/receipt/pool/query/v2',
    method: 'GET',
    params,
  });
};

export const getReceiptFolderList = (params) => {
  return fetch({
    url: '/api/receipt/housekeeper/query',
    method: 'GET',
    params,
  });
};

export const getReceiptFolderDoneList = (params) => {
  return fetch({
    url: '/api/receipt/housekeeper/alloted',
    method: 'GET',
    params,
  });
};

export const assignReceipt = (params) => {
  return fetch({
    url: '/receipt/api/receipt/allot',
    method: 'POST',
    data: params,
  });
};

// 开通发票夹
export const openReceiptFolder = (data) =>
  fetch({
    url: '/api/receipt/folder/open',
    method: 'POST',
    data,
  });
// 开通发票夹
export const getReceiptPoolList = (params) =>
  fetch({
    url: '/api/receipt/pool/query',
    method: 'GET',
    params,
  });

// 审批核定费用
export const auditAmountSubmit = (data, query) =>
  fetch({
    url: '/api/invoice/audit/save/invoice',
    method: 'POST',
    data,
    params: { utcTime: true, isDateCombinedUTC: false, isApproval: true, vatAndTaxStrategy: 'MANUAL', ...query },
  });

//判断是否可以自动核小金额
export const changeFeeAutomatic = (data) =>
  fetch({
    url: '/api/invoice/audit/modify/confirm',
    method: 'POST',
    data,
  });
// 费用可抵扣信息修改
export const getInvoiceTaxRate = (params) =>
  fetch({
    url: '/api/invoice/taxRate',
    method: 'GET',
    params,
  });

// 所有开启和不开启的会计期间列表
export const getAccountingPeriodList = (params) =>
  fetch({
    url: '/api/periods/query/open/v2',
    method: 'GET',
    params,
  });

/**
 * @param data receiptList[]
 * @param logic  1000 生成费用，1001 分别生成费用
 * @param invoiceOID 费用内发票分组需要
 * @returns {*} [receiptGroup]
 */
export const getReceiptGroups = (data, logic, invoiceOID = '') =>
  fetch({
    url: `/receipt/api/receipt/group/auto/${logic}?invoiceOID=${invoiceOID}`,
    method: 'POST',
    data,
  });

export const saveReceiptFold = (data) => {
  return fetch({
    url: '/receipt/api/receipt/housekeeper/save',
    method: 'POST',
    data,
  });
};

// 仅用于费用内发票分组
export const getReceiptGroupsV2 = (data, logic) =>
  fetch({
    url: `/receipt/api/receipt/group/auto/v2/${logic}`,
    method: 'POST',
    data,
  });
/**
 * 发票自动生成费用s
 * @param data
 * @returns {Promise | Promise<unknown> | undefined}
 */
export const receiptAutoCreateInvoice = (data) =>
  fetch({
    url: '/invoice/api/invoices/auto/create',
    method: 'POST',
    data,
  });
// 查询发票的金额占用情况
export const getReceiptUsedMsg = (params) =>
  fetch({
    url: '/receipt/api/invoice/amount/details',
    method: 'GET',
    params,
  });
// 获取税率是否单一配置
export const getTaxRateStrategy = () =>
  fetch({
    url: '/api/config/taxRate/strategy',
    method: 'GET',
    nativeResponseSerializer: 'number',
  });

//获取费用标签信息
export const getExpenseTagList = (params) =>
  fetch({
    url: '/api/expense/labels?labelCategory=2',
    method: 'GET',
  });

export const getUnitOptions = (params = {}) => {
  return fetch({
    url: '/api/custom/enumerations/items/by/type?systemCustomEnumerationType=70005&paged=false',
    method: 'GET',
    params,
  });
};

//获取付款方式列表
export const getApplicationPaymentMethodList = () => {
  return fetch({
    url: '/payment/api/cash/payment/method/query/all',
    method: 'GET',
  });
};
// 修改差补信息
export const updateSubsidy = (data) => {
  return fetch({
    url: '/api/expense/report/subsidy/detail/update',
    method: 'PUT',
    data,
  });
};

// 获取扬招缓存
export const getWaveTravelCache = (params) => {
  return fetch({
    url: '/api/invoice/taxi/cache',
    method: 'GET',
    params,
  });
};
// 更新扬招信息
export const updateWaveTravelCache = (data) => {
  return fetch({
    url: '/api/invoice/taxi/cache',
    method: 'POST',
    data,
    nativeResponseSerializer: 'string',
  });
};
// 删除扬招缓存
export const deleteWaveTravelCache = (invoiceTaxCacheId) => {
  return fetch({
    url: `/api/invoice/taxi/cache/${invoiceTaxCacheId}`,
    method: 'DELETE',
    nativeResponseSerializer: 'boolean',
  });
};
// 发票对比
export const compareInvoice = ({ data, isFinance }) =>
  fetch({
    url: `/receipt/api/receipt/compare?isFinance=${isFinance}`,
    method: 'POST',
    data,
  });

// 获取帐号扩展信息
export const getAccountMoreInfo = (bankAccountId) => {
  return fetch({
    url: `/supplier/api/ven/bank/forms/values/${bankAccountId}`,
    method: 'GET',
  });
};

// 获取替票费用类型
export const getExpenseReplaceType = (page, size, keyword) => {
  return fetch({
    url: '/api/custom/enumerations/items/by/type',
    method: 'GET',
    params: {
      systemCustomEnumerationType: 1021,
      page,
      size,
      keyword,
    },
  });
};

// 获取合同分摊行关联的申请单分摊行信息
export const getContractApplicationApportion = (params) => {
  return fetch({
    url: '/api/contract/budget/apportionment/related/merge',
    method: 'GET',
    params,
  });
};

// 获取合同关联的申请单可导入的默认分摊行信息
export const getContractImportApportions = (params) => {
  return fetch({
    url: '/api/contract/budget/apportionment/merge/related',
    method: 'GET',
    params,
  });
};

// 费用可抵扣信息修改
export const getRelativeClaim = (params) =>
  fetch({
    url: '/api/invoice/associated/report/info',
    method: 'GET',
    params,
  });

//获取指定公司信息
export function getCompany(companyOID) {
  return fetch({
    url: '/api/companies/' + companyOID,
    method: 'GET',
  });
}

export function getJobId(companyOID) {
  return fetch({
    url: `/api/user/jobs/find/company/main/job?companyOID=${companyOID}`,
    method: 'GET',
  });
}

// 获取预付分摊行关联的申请单分摊行信息
export const getPrePayApplicationApportion = (params) => {
  return fetch({
    url: '/api/prepayment/line/budget/apportionment/related/merge',
    method: 'GET',
    params,
  });
};

// 获取预付可导入申请单分摊行列表信息
export const getPrePayImportApportions = (params) => {
  return fetch({
    url: '/api/prepayment/line/budget/apportionment/merge/related',
    method: 'GET',
    params,
  });
};

export const getPeriodByDate = (params) => {
  return fetch({
    url: '/api/periods/query/open/v2',
    method: 'GET',
    params,
  });
};

export const getPeriod = (params) => {
  return fetch({
    url: '/api/periods/query',
    method: 'POST',
    data: params,
  });
};

export const getAccountingPeriod = (params) => {
  return fetch({
    url: '/api/periods/query/all',
    method: 'GET',
    params,
  });
};

export const getAccrualRelatedApportionLine = (params) => {
  return fetch({
    url: '/api/accrued/expense/line/budget/apportionment/related/merge',
    method: 'GET',
    params,
  });
};

//根据金额来刷发票本次报销金额
export const getReceiptAmountDefault = (params) => {
  return fetch({
    url: '/receipt/api/receiptAmount/default',
    method: 'POST',
    data: params,
  });
};

// 获取对公发票池发票
export const getPublicPayPoll = (data, query) => {
  return fetch({
    url: '/receipt/api/receipt/vicp/list',
    method: 'POST',
    data,
    params: query,
  });
};

// 根据付款行id和币种获取原币待支付金额
export const getPaymentAmountByCurrency = (paymentScheduleId, currency) => {
  return fetch({
    url: '/api/payment/schedule/get/amount/by/modify/currency',
    method: 'GET',
    params: { paymentScheduleId, currency },
  });
};

// 增改分摊模板
export const addApportionTemplate = (params) => {
  return fetch({
    url: '/api/expense/apportionment/template',
    method: 'POST',
    data: params,
  });
};

//模板分摊模板
export const getApportionTemplate = (params) => {
  return fetch({
    url: '/api/expense/apportionment/template',
    method: 'get',
    params,
  });
};

//导入分摊模板
export const importApportionTemplate = (params) => {
  return fetch({
    url: '/api/expense/apportionment/template/use',
    method: 'get',
    params,
  });
};
// 删除分摊模板
export const deleteApportionTemplate = (id) => {
  return fetch({
    url: `/api/expense/apportionment/template?id=${id}`,
    method: 'delete',
  });
};

export const getCityDistance = (params) => {
  return fetch({
    url: '/location-service/api/location/distance/query',
    method: 'get',
    params,
  });
};

export const getChatgptExpense = (params) => {
  return fetch({
    url: '/api/expense/type/recommend/gpt',
    method: 'post',
    data: params,
  });
};

/**
 * @desc 查询匹配命中公司分摊模板且生成分摊数据接口
 * @param {*} params
 * @returns
 */
export const getApportionTemplateUse = (params) => {
  return fetch({
    url: '/api/company/apportion/template/hit/use',
    method: 'get',
    params,
  });
};

/**
 * @desc 查询匹配相关人获取的分摊
 * @param {*} params
 * @returns
 */
export const getRelatedPersonApportion = (params) => {
  return fetch({
    url: '/api/expense/apportionment/share/equally',
    method: 'post',
    data: params,
  });
};

export const checkReceipts = (params) => {
  return fetch({
    url: '/api/receipt/batch/save/report',
    method: 'post',
    data: params,
  });
};
